import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import UzenetTableDto from '../dto/UzenetTableDto';

class UzenetTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'uzenetekTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<UzenetTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, UzenetTableDto)))
				.catch(reject);
		});
	}
}

export default new UzenetTableService();
